/*
Description: This is the file that will handle interacting with the PT Everywhere EMR
Date: 1/13/2024
Author: Jacob Michalski

TODO:
    Add support for Choose All Questions on the server

PT Everywhere Specific Notes:
- The following got all questions
                                                    -iterate over the questions with this
    console.log(document.querySelectorAll('intake-form-configuration-card'))

- The following gets a list of the 2 text boxes (if len != 2 then its probs not a Long Answer)
    console.log(document.querySelectorAll('intake-form-configuration-card')[0].querySelectorAll('textarea'))
                                                                                                        - 0 is the question, 
                                                                                                        - 1 is the answer
                                                                                                            - .value lets us get and manipulate
    console.log(document.querySelectorAll('intake-form-configuration-card')[0].querySelectorAll('textarea')[1].value = "hi")

- Can confirm, choose all that apply has 1 text box naturally (I'd imagine this is slightly different when filling out for reals)
    - It is an 'intake-form-multiple-choice'
    - This get's us the choices
    console.log(document.querySelectorAll('intake-form-configuration-card')[21].querySelectorAll('intake-form-multiple-choice')[0].querySelectorAll('label'))
        - innerHTML to get the values out
            - console.log(document.querySelectorAll('intake-form-configuration-card')[21].querySelectorAll('intake-form-multiple-choice')[0].querySelectorAll('label')[0].innerHTML)
        - .parentElement.querySelector("input").checked = true
            - console.log(document.querySelectorAll('intake-form-configuration-card')[21].querySelectorAll('intake-form-multiple-choice')[0].querySelectorAll('label')[0].parentElement.querySelector("input").checked = true)

- Rich text 
    console.log(document.querySelectorAll('intake-form-configuration-card')[11].querySelector("ck-textbox"))


- Hardcoded questions to avoid
    - Consent to Treat
    - Signature
    - ""    (Empty)
    - If "Other", please elaborate.
*/

/**
    Official Functions
*/
// function getPageInfo() {
export function getPageInfo() {
  /*
    Description: This function will get the page info from the note
    Return: A dictionary with the page info
        {
            "URL": Base URL for the page,
            "Note Type": "PT Daily/SOAP Note",...
        }
    */
  const baseURL = window.location.origin;

  // Check if the element exists and get its text content
  let noteType = null;
  let noteTypeElement = document.querySelector(
    "div[ng-if='!treatmentnoteTemplate']"
  );
  noteType = noteTypeElement ? noteTypeElement.textContent.trim() : null;

  if (!noteTypeElement) {
    noteTypeElement = document.querySelector(
      "input[ng-model='currentTreatmentNotes.NoteName']"
    );
    noteType = noteTypeElement ? noteTypeElement.value.trim() : null;
  }

  if (!noteType) {
    noteTypeElement = document.querySelector("label[for='selectTemplateNote']");
    noteType = noteTypeElement
      ? noteTypeElement.nextElementSibling.querySelector(
          "option[selected='selected']"
        ).innerText
      : null;
  }

  if (!noteType) {
    noteType = 'PT Everywhere Note';
  }

  return {
    URL: baseURL,
    'Note Type': noteType
  };
}

// function getPatientInfo() {
export function getPatientInfo() {
  /*
    Description: This function will get the patient info from the note
    Return: A dictionary with the patient info
    {
        "EMR ID": 0x1234 or "michalskij"
        "First Name":firstName,
        "Last Name": lastName,
        "DOB": dob, (01/12/1990)
    }
    */
  // This is the element active in the list on the left
  let nameElement = document
    .querySelector('.active')
    .querySelector('.text strong');
  // name=ctl00_cp1_patientFirst - This is actually only in the search
  // use the query selector to get the patient info
  if (!nameElement) {
    nameElement = document.querySelector(
      "div[ng-if='selectedDashboardPatient']"
    );
  }

  // If they are looking at the patient chart rather than new doc it's here
  if (!nameElement) {
    nameElement = document.querySelector('.user-info .title');
  }

  // Sometimes the name is in a different element... - this is actually just the first patient in the list
  // if (!nameElement) {
  //     nameElement = document.querySelector('div[id^="selectPatientAppointment"]')
  //     nameElement = nameElement.querySelector('span[title]')
  // }

  // If we still can't find it, then we are in the wrong place
  if (!nameElement) {
    console.warn('Unable to extract patient name from the EMR');
    return null;
  }

  const fullName = nameElement.textContent.trim();
  const fullNameArray = fullName.split(' ');
  const firstName = fullNameArray[0];
  const lastName = fullNameArray[fullNameArray.length - 1];

  const emrID = fullName; // Couldn't find an EMR ID on the page so just use the whole name
  const dob = '05/29/2023'; // PT Everywhere doesn't show DOB on the page

  return {
    'EMR ID': emrID,
    'First Name': firstName,
    'Last Name': lastName,
    DOB: dob
  };
}

/* 
questions - This is where we will store the questions
          - a list of dictionaries
     [{
        "Question": "Where was the injury?", 
        "Type": "Multiple Choice", 
        "Choices": ["Back", "Neck", "Shoulder"]
     },
        ...
        ]

*/
var questions = [];

/*
question Interactions - This is where we will store the interactions for each question
                        - a dictionary of dictionaries
         {
            "Where was the injury?": {
                "Type": "Multiple Choice",
                "Choices"{
                    "Back": () => {click the back button},
                    "Neck": () => {click the neck button},
                    "Shoulder": () => {click the shoulder button}
                }
            },
        },
        {
            "What is the injury?": {
                "Type": "Long Answer",
                "Input": (val) => {input the value into the input box}
        }
            ...
         }
*/
var questionInteractions = {};

// Feature flag `pte_custom_note_types`: read Open Answer and Table cards (custom templates).
let customNoteTypesEnabled = false;

export function getQuestions(
  _isWebPTUser?: any,
  _dropdownCache?: any,
  _replyType?: any,
  _empowerNewVersion?: any,
  _targetTab?: any,
  enableCustomNoteTypes?: boolean
) {
  // Background readers omit the flag and keep the last value.
  if (enableCustomNoteTypes !== undefined) {
    customNoteTypesEnabled = enableCustomNoteTypes === true;
  }

  // Clear out the old every time.
  questions = [];
  questionInteractions = {};

  // export function getQuestions() {
  var questionList = document.querySelectorAll(
    'intake-form-configuration-card'
  );

  // Check if we need to click the edit button
  let spanElement = document.querySelector('span[title="Edit"]');
  if (spanElement) {
    spanElement.click();
    questionList = document.querySelectorAll('intake-form-configuration-card');
  }

  questionList.forEach((questionElement) => {
    try {
      let qSummary = getQ(questionElement);
      if (!qSummary) {
        return;
      }
      questionInteractions[qSummary['Question']] = qSummary;
      questions.push(qSummary);
    } catch (e) {
      console.error('Error getting question: ');
      console.error(e);
    }
  });

  return questions;
}

export function answerQuestions(answers) {
  /*
    Description: This function will take the answers and populate the questions
    
    Args: 
        answers: A dictionary of answers
            "Question": "The question in question"
            "Answer": "The answer to the question"
   
    Return: A list of any questions that were not answered, perhaps the answer didn't match the questions expected or whatnot...
        [
            {
                Question: "Where was the injury?", 
                Answer: "Back" 
                Error: "The error message" (Choice not found, etc)
            },
            ...
        }

    */
  var errors = [];
  answers.forEach((answer) => {
    var error = answerQuestion(answer['Question'], answer['Answer']);
    if (error) {
      errors.push({
        Question: answer['Question'],
        Answer: answer['Answer'],
        Error: error
      });
    }
  });
  console.error('Errors:');
  console.error(errors);
  return errors;
}

export function answerQuestion(question, answer, replyType) {
  /*
    Description: This function will take the answer and populate the question
    
    Args: 
        question: The question in question
        answer: The answer to the question
   
    Return: null if success otherwise a string with the error message
    */

  // console.log("Answering Question: '" + question + "' with '" + answer+"'")

  // Make sure the question exists
  if (questionInteractions[question] == null) {
    getQuestions();
    if (questionInteractions[question] == null) {
      console.error('Question not found');
      console.log(question);
      console.log(questionInteractions);
      // console.log(questionInteractions)
      // console.log(Object.keys(questionInteractions))

      return 'Question not found';
    }
  }

  // If the user clicked into an editor, blur it so we don't overwrite that same active field.
  pteDeactivateEditing();

  // If it is a Long Answer or long answer, just populate the input
  if (questionInteractions[question]['Input']) {
    questionInteractions[question]['Input'](answer, replyType);
    return true;
  }

  // Check if the answer is a list of answers or just a single answer
  if (Array.isArray(answer)) {
    // Choose All
    var notFoundAnswers = [];
    for (var i = 0; i < answer.length; i++) {
      if (answer[i] in questionInteractions[question]['Choices']) {
        console.log('Answer found ' + answer[i]);
        questionInteractions[question]['Choices'][answer[i]](true);
        // sleep(1000).then(() => {
        //     questionInteractions[question][answer[i]]()
        // });
      } else {
        notFoundAnswers.push(answer[i]);
      }
    }
    if (notFoundAnswers.length > 0) {
      console.error('The following answers were not found: ' + notFoundAnswers);
      return 'The following answers were not found: ' + notFoundAnswers;
    } else {
      return true;
    }
  } else {
    // Multiple Choice
    if (answer in questionInteractions[question]['Choices']) {
      questionInteractions[question]['Choices'][answer]();
      return true;
    } else {
      console.error('Answer not found');
      console.log('Question: ' + question);
      console.log('Answer:' + answer);
      console.log(questionInteractions[question]['Choices']);
      return 'Answer not found';
    }
  }
}

/** Helper Functions */

// Some legacy helpers below (kept for reference) rely on page globals.
// Declare as `any` so TypeScript doesn't error during build.
declare const $: any;
declare const angular: any;

function pteIsVisible(el) {
  /**
   * Basic "is this on screen?" check to avoid hidden/template editors.
   */
  const style = getComputedStyle(el);
  if (style.visibility === 'hidden' || style.display === 'none') return false;
  const rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

function pteDeactivateEditing() {
  /**
   * PT Everywhere can keep a focused editor "active" and route updates there.
   * Before filling, blur whatever is active so we don't overwrite the field the user clicked.
   */
  try {
    const ae = document.activeElement as HTMLElement | null;
    ae?.blur?.();
    window.getSelection?.()?.removeAllRanges?.();
  } catch {
    // no-op
  }
}

function pteLooksLikeHtml(s: string) {
  return /<\/?[a-z][\s\S]*>/i.test(s);
}

function pteEscapeHtml(s: string) {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function pteNormalizeAnswerText(raw: any) {
  // Handle both real newlines and literal "\n" sequences.
  return String(raw ?? '')
    .replace(/\r\n/g, '\n')
    .replace(/\\n/g, '\n')
    .trim();
}

function pteApplyNewlineFormatting(text: string) {
  const lines = String(text || '').split('\n');
  const out: string[] = [];
  let inHeaderSection = false;
  let inDashList = false;

  const isHeaderLine = (l: string) => {
    const t = l.trim();
    return t !== '' && !t.startsWith('-') && /:\s*$/.test(t);
  };

  for (const rawLine of lines) {
    const line = String(rawLine ?? '');
    const t = line.trim();

    if (t === '') {
      out.push('');
      inDashList = false;
      continue;
    }

    if (isHeaderLine(t)) {
      out.push(t);
      inHeaderSection = true;
      inDashList = false;
      continue;
    }

    if (t.startsWith('-')) {
      // Normalize "-foo" / "-- foo" into "- foo"
      const item = t.replace(/^-+\s*/, '').trim();
      out.push(`- ${item}`);
      inDashList = true;
      continue;
    }

    if (inHeaderSection || inDashList) {
      out.push(`- ${t}`);
      continue;
    }

    out.push(t);
  }

  return out.join('\n').trim();
}

function pteFormatForTextarea(raw: any) {
  const text = pteNormalizeAnswerText(raw);
  return pteApplyNewlineFormatting(text);
}

function pteFormatForRichTextHtml(raw: any) {
  const text = pteApplyNewlineFormatting(pteNormalizeAnswerText(raw));
  if (pteLooksLikeHtml(text)) return text; // already formatted upstream

  // Render header/bullet structure into HTML while preserving newlines.
  const lines = text.split('\n');
  const htmlParts: string[] = [];
  let list: string[] = [];

  const flushList = () => {
    if (list.length === 0) return;
    htmlParts.push(
      `<ul>${list.map((p) => `<li>${pteEscapeHtml(p)}</li>`).join('')}</ul>`
    );
    list = [];
  };

  const isHeaderLine = (l: string) => {
    const t = l.trim();
    return t !== '' && !t.startsWith('-') && /:\s*$/.test(t);
  };

  for (const rawLine of lines) {
    const t = String(rawLine ?? '').trim();
    if (t === '') {
      flushList();
      htmlParts.push('<br>');
      continue;
    }

    if (isHeaderLine(t)) {
      flushList();
      htmlParts.push(`<strong>${pteEscapeHtml(t)}</strong><br>`);
      continue;
    }

    if (t.startsWith('- ')) {
      list.push(t.slice(2).trim());
      continue;
    }

    flushList();
    htmlParts.push(`${pteEscapeHtml(t)}<br>`);
  }

  flushList();
  return htmlParts.join('').replace(/(<br>)+$/g, '');
}

function ptePickLargestVisible(els: HTMLElement[]) {
  // Prefer the largest visible editor surface (usually the live ck editor).
  let best: HTMLElement | null = null;
  let bestArea = -1;
  for (const el of els) {
    if (!pteIsVisible(el)) continue;
    const r = el.getBoundingClientRect();
    const area = r.width * r.height;
    if (area > bestArea) {
      bestArea = area;
      best = el;
    }
  }
  return best;
}

function getRichTextIndexForCard(cardEl) {
  // Compute a stable rich-text index based on card order.
  const cards = Array.from(
    document.querySelectorAll('intake-form-configuration-card')
  );

  const isRichTextCard = (c) => {
    // `ng-if` strings vary across templates, so use substring match.
    if (c.querySelector('div[ng-if*="QUESTION_TYPE_KEY.RICHTEXT_EDITOR"]'))
      return true;
    if (c.querySelector('ck-textbox')) return true;
    return false;
  };

  const richCards = cards.filter(isRichTextCard);
  return richCards.indexOf(cardEl);
}

function findVisibleCkTextboxByIndex(idx) {
  // Use the live note container when possible (avoid hidden/template ck editors).
  const root =
    document.querySelector('.order-question-items') | null ||
    document.querySelector('.order-questions') | null ||
    document.body;

  const cks = Array.from(root.querySelectorAll('.ckTextbox'));
  const visible = cks.filter(pteIsVisible);
  if (visible.length === 0) return null;

  // Out of range -> force label fallback (avoids "everything goes into first/last editor").
  if (idx < 0 || idx >= visible.length) {
    // console.error('Index out of range');
    // console.error(idx);
    // console.error(visible.length);
    // This is the ghost element that is not visible...
    return null;
  }

  return visible[idx];
}

// NOTE, findLiveCkTextboxForSection was failing badly... aka it would not find the correct text
// area ever... and couldn't find a case where the index based lookup wasn't sufficent... so we will ALWASY use the index lookup...
function getQ(questionElement) {
  /**
   * This function will get the question from the question element
   * @param {HTMLElement} questionElement - The question element
   * @returns {dict} - The question summary of this type
   *  {
   *     "Key": "Where was the injury?",
   *     "Question": "Where was the injury?",
   *     "Type": "Multiple Choice",
   *     "Choices": ["Back", "Neck", "Shoulder"]
   *     "Input": func(val) => {input.value = val}
   *  }
   */

  // Open Answer cards (custom templates) have no title element in the Edit layout, so they are
  // handled before the title lookup below.
  const openAnswer = questionElement.querySelector(
    'div[ng-if="ngModel.QuestionType == QUESTION_TYPE_KEY.OPEN_ANSWER"] intake-form-open-answer'
  );
  if (openAnswer && customNoteTypesEnabled) {
    return getOpenAnswerQ(questionElement);
  }

  // Default initialization
  let questionTitle = null;
  let questionKey = null;
  let qType = null;
  let choices = [];
  let qBody = null;
  let qInput = null;
  let input = null;
  let inputFunc = null;

  // Get the question text and key
  let questionTitleElement = questionElement.querySelector(
    'textarea[placeholder*="title"]'
  );
  if (questionTitleElement) {
    // Identified Type 1 - Document Filling out a form
    // Remove new lines and colons
    questionTitle = questionTitleElement.value;
    questionTitle = questionTitle.trim().replace(/\n/g, ' ').replace(':', '');

    qBody = questionElement.querySelector('div[class^="card-body"]');
  } else if (questionElement.querySelector('label')) {
    // Look for a label element
    questionTitleElement = questionElement.querySelector('label');
    if (!questionTitleElement) {
      console.error('Unable to find the question title element');
      return null;
    }
    questionTitle = questionTitleElement.textContent;
    questionTitle = questionTitle
      .trim()
      .replace(/\n/g, ' ')
      .replace(':', '')
      .trim();

    qBody = questionElement.querySelector('div.control-section[ng-if]');
  } else {
    // If we did not find the question title, then we are in the wrong place
    console.error('Unable to find the question title element');
    return null;
  }

  // Normalized both types of questions to have the same format
  if (!qBody) {
    console.error('Unable to find the question input element');
    return null;
  }

  // Fix for empty title of question, need to use the header...
  if (questionTitle == '' || questionTitle == null) {
    let sectionHead =
      questionElement.parentElement.parentElement.querySelector(
        '.question-title'
      );
    if (sectionHead) {
      questionTitle = sectionHead.textContent.trim();
    }
  }

  // Copy the value of the question title to the question key
  questionKey = questionTitle.trim();
  qInput = qBody.querySelector('.ng-scope');
  let existingNote = null;

  if (qInput && qInput.getAttribute('ng-if') === '!isReadOnly') {
    // This is a Long Answer Question
    // The format for this type of question is different than the others...
    qType = 'Long Answer';
    input = qBody.querySelector('textarea');
    existingNote = getExistingNote(input.value);
    inputFunc = (val, replyType) => {
      if (isEmptyOrNull(val)) {
        return;
      }
      const formatted = pteFormatForTextarea(val);
      if (replyType == 'append') {
        input.value = (input.value + '\n' + formatted).trim();
      } else {
        input.value = formatted;
      }
      input.dispatchEvent(new Event('input'));
    };
  } else if (
    qInput &&
    qInput.getAttribute('ng-if') ===
      'ngModel.QuestionType == QUESTION_TYPE_KEY.DATE'
  ) {
    // This is a Date Questions
    qType = 'Date';
    input = qInput.querySelector('textarea');
    // Take a date object and fill it in with the date as MM/DD/YYYY
    inputFunc = (val) => {
      let date = new Date(val);
      input.value = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
      input.dispatchEvent(new Event('input'));
    };
  } else if (
    qInput &&
    qInput.getAttribute('ng-if') ===
      'ngModel.QuestionType == QUESTION_TYPE_KEY.MULTIPLE_CHOICE'
  ) {
    // This is a multiple-choice/Choose All question
    qType = 'Choose All';

    // Get the choices
    let choicesClickable = {};
    let choiceElements = qInput.querySelectorAll('input');
    choiceElements.forEach((choiceElement) => {
      const choiceText = choiceElement.parentElement.textContent.trim();
      choices.push(choiceText);
      choicesClickable[choiceText] = choiceElement;
    });
    inputFunc = (key) => {
      if (choicesClickable[key]) {
        // only click it if "ng-empty" if in the class list (i.e. it is not already selected)
        if (choicesClickable[key].classList.contains('ng-empty')) {
          choicesClickable[key].click();
          input.dispatchEvent(new Event('input'));
        }
      } else {
        console.error(
          `Unable to find the choice ${key} in question ${questionTitle}`
        );
      }
    };
  } else if (
    qInput &&
    qInput.getAttribute('ng-if') ===
      'ngModel.QuestionType == QUESTION_TYPE_KEY.SLIDER'
  ) {
    // This is a slider question - Effectively Multiple Choice
    qType = 'Multiple Choice';

    input = qInput.querySelector('input');
    // Convert min to int and max to int
    let min = parseInt(input.getAttribute('min'));
    let max = parseInt(input.getAttribute('max'));
    // Interpolate the values so that we have 11 choices, force to an int
    let step = Math.round((max - min) / 10);
    let choicesClickable = {};
    for (let i = min; i <= max; i += step) {
      choices.push(i.toString());
      choicesClickable[i.toString()] = () => {
        input.value = i.toString();
        input.dispatchEvent(new Event('input'));
      };
    }
    inputFunc = (key) => {
      if (choicesClickable[key]) {
        choicesClickable[key]();
      } else {
        console.error(
          `Unable to find the choice ${key} in question ${questionTitle}`
        );
      }
    };
  } else if (
    qInput &&
    qInput.getAttribute('ng-if') ===
      'ngModel.QuestionType == QUESTION_TYPE_KEY.RICHTEXT_EDITOR'
  ) {
    // This is a Long answer Question
    // The format for this type of question is different than the others...
    qType = 'Long Answer';
    // Stable index to prevent all writes from going into the first visible editor.
    const richTextIndex = getRichTextIndexForCard(questionElement);
    const visibleWrapper = findVisibleCkTextboxByIndex(richTextIndex);
    if (!visibleWrapper) {
      // console.log('Unable to find the visible wrapper for question', questionTitle, 'This is likely a ghost element...the real one will be found too');
      return null;
    }
    existingNote = getExistingNote(visibleWrapper?.innerText);
    inputFunc = (val, replyType) => {
      if (isEmptyOrNull(val)) {
        return;
      }

      // Re-query the live editor at write time (PUSH_ANSWER).
      // PT Everywhere can (and does) re-render/replace DOM nodes between GET_DOM and PUSH_ANSWER.

      /* This is not okay
      const byIndex = findVisibleCkTextboxByIndex(richTextIndex);
      const byLabel = findLiveCkTextboxForSection(
        questionTitle,
        questionElement
      );
      const wrapper = byIndex || byLabel;

      if (!wrapper) {
        return;
      } */

      // ONLY use the index, the other lookup function was failing badly... see comment above
      const wrapper = findVisibleCkTextboxByIndex(richTextIndex);
      if (!wrapper) {
        // This is the ghost element that is not visible...
        console.error('Unable to find the wrapper');
        return;
      }

      const formattedHtml = pteFormatForRichTextHtml(val);
      if (replyType === 'append' && wrapper.innerHTML.trim()) {
        wrapper.innerHTML = (wrapper.innerHTML + '<br>' + formattedHtml).trim();
      } else {
        wrapper.innerHTML = formattedHtml;
      }

      wrapper.dispatchEvent(new Event('input', { bubbles: true }));
      wrapper.dispatchEvent(new Event('change', { bubbles: true }));
      wrapper.blur();
    };
  } else if (
    customNoteTypesEnabled &&
    qInput &&
    qInput.getAttribute('ng-if') ===
      'ngModel.QuestionType == QUESTION_TYPE_KEY.TABLE_CONTROL' &&
    questionElement.querySelectorAll('.ckTextbox').length === 1
  ) {
    // Table (custom templates) holding one rich text cell, e.g. a Plan checklist plus a notes box.
    // Only the rich text cell is filled; the other cells (checkboxes) are left to the provider.
    // Like the Rich Text branch, this reads both the editor (ck-textbox) and the read-only view (ck-view).
    qType = 'Long Answer';
    existingNote = getExistingNote(
      questionElement.querySelector('.ckTextbox')?.innerText
    );
    inputFunc = (val, replyType) => {
      if (isEmptyOrNull(val)) {
        return;
      }

      const wrapper = questionElement.querySelector('.ckTextbox');
      if (!wrapper) {
        console.error('Unable to find the table rich text editor');
        return;
      }

      const formattedHtml = pteFormatForRichTextHtml(val);
      if (replyType === 'append' && wrapper.innerHTML.trim()) {
        wrapper.innerHTML = (wrapper.innerHTML + '<br>' + formattedHtml).trim();
      } else {
        wrapper.innerHTML = formattedHtml;
      }

      wrapper.dispatchEvent(new Event('input', { bubbles: true }));
      wrapper.dispatchEvent(new Event('change', { bubbles: true }));
      wrapper.blur();
    };
  } else {
    // No dice, we don't know what this is
    return null;
  }

  if (!qType) {
    console.error('Unable to find the question type');
    return null;
  }

  questionTitle = questionTitle.trim();

  return {
    Key: questionKey,
    Question: questionTitle,
    Type: qType,
    ExistingNote: existingNote,
    Choices: choices,
    Input: inputFunc
  };
}

function getOpenAnswerQ(questionElement) {
  // Use the card's own label when it has one (View layout), otherwise the section heading.
  let questionTitle = (questionElement.querySelector('label')?.textContent || '')
    .trim()
    .replace(/\n/g, ' ')
    .replace(':', '')
    .trim();
  if (!questionTitle) {
    const sectionHead =
      questionElement.parentElement?.parentElement?.querySelector(
        '.question-title'
      );
    questionTitle = sectionHead ? sectionHead.textContent.trim() : '';
  }
  if (!questionTitle) {
    console.error('Unable to find the open answer section title');
    return null;
  }

  // The textarea only renders while the note is editable; a read-only note shows a div instead.
  const findTextarea = () =>
    questionElement.querySelector('intake-form-open-answer textarea');
  const findReadOnlyView = () =>
    questionElement.querySelector(
      'intake-form-open-answer div[ng-if="isReadOnly"]'
    );

  const textarea = findTextarea();
  return {
    Key: questionTitle,
    Question: questionTitle,
    Type: 'Long Answer',
    ExistingNote: getExistingNote(
      textarea ? textarea.value : findReadOnlyView()?.textContent
    ),
    Choices: [],
    Input: (val, replyType) => {
      if (isEmptyOrNull(val)) {
        return;
      }
      const formatted = pteFormatForTextarea(val);

      const input = findTextarea();
      if (input) {
        if (replyType == 'append') {
          input.value = (input.value + '\n' + formatted).trim();
        } else {
          input.value = formatted;
        }
        input.dispatchEvent(new Event('input'));
        return;
      }

      // Read-only note: show the text, as the Rich Text branch does for its read-only view.
      const view = findReadOnlyView();
      if (!view) {
        console.error('Unable to find the open answer input');
        return;
      }
      if (replyType == 'append' && view.textContent.trim()) {
        view.innerText = (view.textContent + '\n' + formatted).trim();
      } else {
        view.innerText = formatted;
      }
    }
  };
}

/** Old Functions */
function getSelector(elm) {
  // This function will return the selector for a given element
  if (elm.tagName === 'BODY') return 'BODY';
  const names = [];
  while (elm.parentElement && elm.tagName !== 'BODY') {
    if (elm.id) {
      names.unshift('#' + elm.getAttribute('id')); // getAttribute, because `elm.id` could also return a child element with name "id"
      break; // Because ID should be unique, no more is needed. Remove the break, if you always want a full path.
    } else {
      let c = 1,
        e = elm;
      for (; e.previousElementSibling; e = e.previousElementSibling, c++);
      names.unshift(elm.tagName + ':nth-child(' + c + ')');
    }
    elm = elm.parentElement;
  }
  return names.join('>');
}

const AVOID_QUESTIONS_WITH = [
  'Consent to Treat',
  'Signature',
  'If "Other", please elaborate.'
];

// 'Input':actionableItem, // for Long Answer
// 'Choices':{choice:actionable},           // for MC/choose many
//  }
// var questionInteractions = {};  // Dictionary of question: {'Type':'',

function fillForm(question, answer, questionInteractions) {
  console.log(`Answering questions ${question}`);
  if (questionInteractions[question] == null) {
    console.error('Question not found in the questionInteractions object');
    // log all the questions in the questionInteractions object
    console.log('Questions in the questionInteractions object are: ');
    console.log(Object.keys(questionInteractions));

    // TODO handle the question not being an exact match (We should do this on the server side)
    return false;
  }

  // Get the question interaction
  var qInteraction = questionInteractions[question];

  if (qInteraction['Type'] == 'Long Answer') {
    console.log('Long Answer question');
    txtBox = qInteraction['Input'];
    if (txtBox == null) {
      console.error('Failed to find the input for the Long Answer question');
      return false;
    } else {
      // console.log("Found the input for the Long Answer question, setting the value")
      if (qInteraction['RichText'] != null) {
        // txtBox = document.querySelector(txtBox)
        // txtBox.innerHTML = answer

        // This set's the back end data
        var elem = $(txtBox);
        var scope = angular.element(elem).scope();
        scope.$apply(function () {
          scope.ngModel.Answer = answer;
        });

        // This sets the text that is displayed
        txtBox = document.querySelector(txtBox).querySelectorAll('div')[2];
        txtBox.innerHTML = answer;
      } else {
        // https://stackoverflow.com/questions/43965572/trigger-input-change-on-website-using-angular-with-chrome-extension-content-scri

        // injectionScript = `var elem = $(${txtBox});
        // var scope = angular.element(elem).scope();
        // scope.$apply(function() {
        //     scope.ngModel.Answer = ${answer};
        // });`
        // angularInjection(injectionScript)
        var elem = $(txtBox);
        var scope = angular.element(elem).scope();
        scope.$apply(function () {
          scope.ngModel.Answer = answer;
        });
      }
      return true;
    }
  }
  // TODO handle the choose many
  else if (qInteraction['Type'] == 'Multiple Choice') {
    thisChoice = document.querySelector(qInteraction['Choices'][answer]);
    if (thisChoice == null) {
      console.error('Answer not found in the choices list');
      console.log('Choices are: ');
      console.log(qInteraction['Choices']);
      return false;
    } else {
      // Pick this one
      // console.log(thisChoice)
      // console.log(qInteraction['Choices'][answer])
      // thisChoice.checked = true;

      // Need to interact with the Angular to get it to work
      var elem = $(qInteraction['Choices'][answer]);
      var scope = angular.element(elem).scope();
      scope.$apply(function () {
        scope.option.ValueOptionAnswers = true;
      });
    }
  } else {
    console.error('Question type not recognized: ' + qInteraction['Type']);
    return false;
  }
}

function getExistingNote(value) {
  if (typeof value !== 'string') {
    return null;
  }

  let val = value?.trim();
  return val === '' ? null : val;
}

function isEmptyOrNull(value) {
  return (
    value === null || value === undefined || value === '' || value === 'None'
  );
}

export async function getLogFromInjector() {
  try {
    const htmlContent = document.documentElement.outerHTML;
    chrome.runtime.sendMessage({
      type: 'INJECTOR_ERROR',
      error: { htmlContent: htmlContent }
    });
    return { htmlContent: htmlContent };
  } catch (error) {
    // Return the full HTML content of the document
    console.error('Error occurred while fetching document:', error);
    getLogFromInjector();
  }
}
